import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { SUMMIT } from "@/constants/summit";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-obsidian">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/assets/brand-logo.png" alt="The Choice summit icon" className="h-9 w-9 object-contain" />
            <span className="font-display text-lg font-bold tracking-[0.18em]">{SUMMIT.name}</span>
          </div>
        <p className="text-sm text-white/50 leading-relaxed max-w-xs">
            {SUMMIT.tagline}. A VVIP, invite-only gathering presented by {SUMMIT.host}.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-400 mb-4">Summit</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-0.5 text-brand-500 shrink-0" />
              <span>{SUMMIT.venue}, {SUMMIT.address}, {SUMMIT.city}</span>
            </li>
            <li>{SUMMIT.dateLabel} · {SUMMIT.timeLabel}</li>
            <li>
              <a
                data-testid="footer-contact-email"
                href={`mailto:${SUMMIT.contactEmail}`}
                className="flex items-center gap-2 hover:text-brand-400 transition-colors"
              >
                <Mail className="h-4 w-4 text-brand-500" /> {SUMMIT.contactEmail}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-contact-phone"
                href={`tel:+1${SUMMIT.contactPhone.replace(/[^0-9]/g, "")}`}
                className="flex items-center gap-2 hover:text-brand-400 transition-colors"
              >
                <Phone className="h-4 w-4 text-brand-500" /> {SUMMIT.contactPhone}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-400 mb-4">Navigate</p>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-brand-400 transition-colors">Overview</Link></li>
            <li><Link data-testid="footer-link-speakers" to="/speakers" className="hover:text-brand-400 transition-colors">Speakers</Link></li>
            <li><Link data-testid="footer-link-rsvp" to="/confirm-attendance" className="hover:text-brand-400 transition-colors">Confirm Attendance</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
          © 2026 {SUMMIT.host} · {SUMMIT.tagline}
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
          Strictly by invitation · VVIP only
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
